__turbopack_context__.v({
  "antall": "HovedEnhet-module__RjGcTa__antall",
  "searchContainer": "HovedEnhet-module__RjGcTa__searchContainer",
  "underenhetLenke": "HovedEnhet-module__RjGcTa__underenhetLenke",
  "utfyllendeInfo": "HovedEnhet-module__RjGcTa__utfyllendeInfo",
  "utfyllendeInfoKompakt": "HovedEnhet-module__RjGcTa__utfyllendeInfoKompakt",
});
